import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SectionHeader from "components/common/SectionHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIdCard, faSteeringWheel } from "@fortawesome/pro-duotone-svg-icons";

const Drivers = () => {

    useEffect(() => {
        document.title = `Drivers`
    }, [])

    return (<>
        <Row>
            <Col>
                <SectionHeader
                    Title='Drivers'
                    Subtitle='Company Drivers'
                    Icon={<FontAwesomeIcon icon={faSteeringWheel} className="me-0 ms-2" size="2x" />}
                />
            </Col>
        </Row>
    </>)
}

export default Drivers